define("shared/components/shared/mavely/links/folder", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.MavelyLinksFolderComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @additional="block"
    @class={{concat-classes "cLB--linkFolders__item u--m__0" (if @isSelected "is--selected")}}
    @onClick={{@selectFolder}}
    @variant="unstyled"
    {{! @glint-expect-error: underscore }}
    data-qa-id="qa--mavely_folder_{{underscore @folder.name}}"
    data-test-id="mavely-folder-{{@folder.id}}-btn"
  >
    <span class="u--ellipsis u--p__r__sm">
      {{@folder.name}}
      {{#if (user-agent "device.isMobile")}}
        ({{@folder.affiliate_links.length}})
      {{/if}}
    </span>
    {{#if (user-agent "device.isMobile")}}
      {{svg-jar "nav-right" class="o--icon--xs"}}
    {{else}}
      <span>
        {{@folder.affiliate_links.length}}
      </span>
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "/2Gx+G1w",
    "block": "[[[8,[39,0],[[16,\"data-qa-id\",[29,[\"qa--mavely_folder_\",[28,[37,1],[[30,1,[\"name\"]]],null]]]],[16,\"data-test-id\",[29,[\"mavely-folder-\",[30,1,[\"id\"]],\"-btn\"]]]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[28,[37,2],[\"cLB--linkFolders__item u--m__0\",[52,[30,2],\"is--selected\"]],null],[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,1],[14,0,\"u--ellipsis u--p__r__sm\"],[12],[1,\"\\n    \"],[1,[30,1,[\"name\"]]],[1,\"\\n\"],[41,[28,[37,4],[\"device.isMobile\"],null],[[[1,\"      (\"],[1,[30,1,[\"affiliate_links\",\"length\"]]],[1,\")\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[41,[28,[37,4],[\"device.isMobile\"],null],[[[1,\"    \"],[1,[28,[35,5],[\"nav-right\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,1,[\"affiliate_links\",\"length\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]]],[]]]]]],[\"@folder\",\"@isSelected\",\"@selectFolder\"],false,[\"shared/ui/button\",\"underscore\",\"concat-classes\",\"if\",\"user-agent\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/mavely/links/folder.hbs",
    "isStrictMode": false
  });
  const MavelyLinksFolderComponent = _exports.MavelyLinksFolderComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksFolderComponent);
});